/* PC STATION LB — Universal Product Description (progressive enhancement, all product pages) */
(() => {
  'use strict';
  const SEL = '[data-pcslb-description-source]';
  const txt = (s) => String(s || '').replace(/\s+/g, ' ').trim();
  const make = (tag, className, text) => {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (text !== undefined) el.textContent = text;
    return el;
  };
  const productTitle = () => txt(document.querySelector('.product__title h1')?.textContent).toLowerCase();

  function heading(node) {
    if (node.nodeType !== 1) return '';
    if (/^H[2-4]$/.test(node.tagName)) return txt(node.textContent);
    if (node.tagName !== 'P') return '';
    const children = [...node.children];
    if (children.length !== 1 || !['STRONG', 'B'].includes(children[0].tagName)) return '';
    if (txt(node.textContent) !== txt(children[0].textContent)) return '';
    const value = txt(node.textContent);
    if (value.length < 3 || value.length > 95) return '';
    if (value.toLowerCase() === productTitle() || productTitle().includes(value.toLowerCase()) && value.length > 24) return '__product_title__';
    return value;
  }
  function getGroups(root) {
    const groups = [{ heading: '', elements: [] }];
    for (const node of [...root.childNodes]) {
      if (node.nodeType === 3 && !txt(node.textContent)) continue;
      const h = heading(node);
      if (h === '__product_title__') continue;
      if (h) { groups.push({heading:h, elements:[]}); continue; }
      groups[groups.length-1].elements.push(node);
    }
    return groups.filter(g => g.elements.some(n => txt(n.textContent) || n.nodeType === 1 && ['IMG','VIDEO'].includes(n.tagName)));
  }
  function parseRow(li) {
    const val = txt(li.textContent);
    const match = val.match(/^([^:\n]{2,54}):\s*(\S[\s\S]*)$/);
    if (!match || /^(https?|www|note|warning)$/i.test(match[1].trim())) return null;
    const label = txt(match[1]);
    const value = txt(match[2]);
    if (!label || !value || /[.!?]$/.test(label)) return null;
    return {label, value};
  }
  function addSpecList(parent, entries, headingLabel) {
    if (!entries.length) return;
    const wrap = make('section','pcslb-desc-structured');
    const title = make('h4','pcslb-desc-structured__heading',headingLabel || 'Technical Specifications');
    wrap.append(title);
    const list = make('dl','pcslb-desc-structured__grid');
    for (const {label,value} of entries) {
      const row = make('div','pcslb-desc-structured__row');
      row.append(make('dt','',label), make('dd','',value));
      list.append(row);
    }
    wrap.append(list);
    parent.append(wrap);
  }
  function addFeatures(parent, lis, headingLabel) {
    if (!lis.length) return;
    const wrap = make('section','pcslb-desc-feature-area');
    wrap.append(make('h4','pcslb-desc-structured__heading',headingLabel || 'Key Features'));
    const list = make('ul','pcslb-desc-feature-grid');
    for (const li of lis) {
      const row = make('li','pcslb-desc-feature');
      for (const node of [...li.childNodes]) row.append(node.cloneNode(true));
      list.append(row);
    }
    wrap.append(list); parent.append(wrap);
  }
  function isSpecHeading(h) {return /specification|technical|hardware|configuration|dimensions|connectivity|performance|specs/i.test(h);}
  function isFeaturesHeading(h) {return /features|highlights|benefits|advantages|key points/i.test(h);}
  function renderGroup(group, container, isFirst) {
    const panel = make('section','pcslb-desc-panel');
    const label = group.heading;
    let nodes = group.elements;
    const hasLists = nodes.some(n => n.nodeType === 1 && ['UL','OL'].includes(n.tagName));
    const isMixed = /feature.*spec|spec.*feature/i.test(label);
    const renderedTitle = label && !isMixed ? label : (!isFirst || hasLists ? '' : 'Product Overview');
    if (renderedTitle) panel.append(make('h3','pcslb-desc-panel__heading',renderedTitle));
    let copied = false;
    let onlyHeadings = true;
    for (const n of nodes) {
      if (n.nodeType === 1 && ['UL','OL'].includes(n.tagName)) {
        const specs=[], features=[];
        for (const li of [...n.querySelectorAll(':scope > li')]) {
          const pair = parseRow(li);
          if (pair) specs.push(pair); else features.push(li);
        }
        if (features.length) addFeatures(panel,features,
          !isMixed && isFeaturesHeading(label) && !specs.length ? '' : 'Key Features');
        if (specs.length) addSpecList(panel,specs,
          !isMixed && isSpecHeading(label) && !features.length ? '' : 'Technical Specifications');
        copied = true;
      } else if (n.nodeType === 1 && n.tagName === 'TABLE') {
        const tableWrap = make('div','pcslb-desc-table-wrap');tableWrap.append(n.cloneNode(true));panel.append(tableWrap);copied=true;
      } else {
        const el=n.cloneNode(true);
        if (n.nodeType===1 && n.tagName==='P' && !txt(n.textContent) && !n.querySelector('img')) continue;
        const box=make('div','pcslb-desc-copy');box.append(el);panel.append(box);copied=true;
        onlyHeadings = false;
      }
    }
    if (copied) container.append(panel);
  }
  function transform(source) {
    if (source.dataset.pcsDescriptionDone === '1') return;
    const groups=getGroups(source);
    if (!groups.length) return;
    const output=make('div','pcslb-description-v2');
    output.setAttribute('aria-label','Product overview and technical information');
    for (const [i,g] of groups.entries()) renderGroup(g,output,i===0);
    if (!output.querySelector('.pcslb-desc-panel')) return;
    source.insertAdjacentElement('afterend',output);
    source.hidden=true;
    source.dataset.pcsDescriptionDone='1';
  }
  function init(root) {
    const scope=root && typeof root.querySelectorAll==='function' ? root:document;
    if (scope.matches && scope.matches(SEL)) {try{transform(scope);}catch(e){console.warn('PCSTATION description fallback:',e);}}
    for(const el of scope.querySelectorAll(SEL)) {try{transform(el);}catch(e){console.warn('PCSTATION description fallback:',e);}}
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});
  else init(document);
  document.addEventListener('shopify:section:load',(event)=>init(event.target));
})();